import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, mergeProps as _mergeProps, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "recs" }
const _hoisted_3 = { class: "recs-top" }
const _hoisted_4 = { class: "recs-title" }
const _hoisted_5 = { class: "recs-contents" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "sp-wrapper-right" }
const _hoisted_9 = {
  class: "content-item-title",
  id: "title"
}
const _hoisted_10 = { class: "tag-container" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "sp-wrapper-bottom" }
const _hoisted_16 = { class: "content-item-date" }
const _hoisted_17 = { class: "content-item-writer" }
const _hoisted_18 = { class: "writer-name" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "like-button" }
const _hoisted_21 = ["id", "checked", "onChange"]
const _hoisted_22 = ["for"]
const _hoisted_23 = ["id", "checked", "onChange"]
const _hoisted_24 = ["for"]
const _hoisted_25 = { class: "contents-search-wrapper" }
const _hoisted_26 = { class: "contents-search" }
const _hoisted_27 = { class: "contents-search-title" }
const _hoisted_28 = { class: "contents-search-tags" }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = ["onClick"]
const _hoisted_31 = {
  key: 0,
  class: "contents-search-title"
}
const _hoisted_32 = { class: "contents-search-writers" }
const _hoisted_33 = ["onClick"]
const _hoisted_34 = { class: "notice" }
const _hoisted_35 = { class: "notice-top" }
const _hoisted_36 = { class: "notice-title" }
const _hoisted_37 = { class: "notice-content" }
const _hoisted_38 = ["onClick"]
const _hoisted_39 = { class: "item-date" }
const _hoisted_40 = { class: "item-title" }
const _hoisted_41 = { class: "banner" }
const _hoisted_42 = {
  key: 1,
  id: "generalpurpose02-00-b01"
}
const _hoisted_43 = { class: "modal home-popup" }
const _hoisted_44 = { class: "modal-header" }
const _hoisted_45 = { class: "modal-body" }
const _hoisted_46 = {
  key: 0,
  class: "popup-contents"
}
const _hoisted_47 = { class: "popup-contents-title" }
const _hoisted_48 = { class: "popup-contents-text" }
const _hoisted_49 = {
  key: 1,
  class: "popup-contents"
}
const _hoisted_50 = { class: "popup-contents-title" }
const _hoisted_51 = { class: "popup-contents-text" }
const _hoisted_52 = {
  key: 2,
  class: "popup-contents"
}
const _hoisted_53 = { class: "popup-contents-title" }
const _hoisted_54 = { class: "popup-contents-text" }
const _hoisted_55 = ["innerHTML"]
const _hoisted_56 = { class: "popup-pagination" }
const _hoisted_57 = { class: "modal-footer" }
const _hoisted_58 = { class: "modal-footer-buttons" }

import { onMounted, ref, reactive, inject } from "vue";
import dayjs from "dayjs";
import { processing, processend } from "@/utils/view";
import { useRoute, useRouter } from "vue-router";
import { Content } from "@/models/contents/content";
import { Tag } from "@/models/contents/tag";
import { Disease } from "@/models/contents/disease";
import { UserAuthorFollow } from "@/models/users/authorFollow";
import { UserArticleFavorite } from "@/models/users/articleFavorite";
import { UserArticleLike } from "@/models/users/articleLikes";
import Header from "@/components/modules/base/Header.vue";
import Footer from "@/components/modules/base/Footer.vue";
import ErrorDialog from "@/views/base/CommonMessage.vue";
import { _$t } from "@/utils/i18n";
import code from "@/constants/code";
import { Profile } from "@/models/profile/profile";
import { useStore } from "vuex";
import { Home } from "@/models/home";
import Modal from "@/components/modules/modal/Modal.vue";
import {
  DailyCondition,
  DailyFeeling,
  DailyNote,
  HospitalVisit,
  Option,
} from "@/models/home/types/indes";

// ---- Interfaces -------------------------------------------------
interface NoticeData {
  articleId: number;
  title: string;
  contentType: number;
  dateFirstPublished: string;
  isRead: boolean;
}

interface ArticleData {
  articleId: number;
  title: string;
  contentType: number;
  coverPhotoUrl: string;
  likeCount: number;
  dateFirstPublished: string;
  diseases: {
    diseaseCode: number;
    diseaseName: string;
  }[];
  tags: {
    tagId: number;
    tagName: string;
  }[];
  poster: {
    adminId: number;
    nickname: string;
  };
  isNew: boolean;
  isFavorite: boolean;
  isLiked: boolean;
}

interface TagData {
  tagId: number;
  tagName: string;
}

interface DiseaseData {
  diseaseCode: number;
  diseaseName: string;
}

interface UserAuthorFollowData {
  posterId: number;
  nickname: string;
}

interface ArticleQueryCond {
  tagIds?: number[];
  diseaseCodes?: number[];
  posterIds?: number[];
}

// ---- Constants ----------------------------------------------
const componentId = "generalpurpose02-01";
const activeMenu = "home";
const page = 1;
const size = 3;

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const router = useRouter();
const store = useStore();
const notices = ref<NoticeData[]>([]);
const articles = ref<ArticleData[]>([]);
const tags = ref<TagData[]>([]);
const diseases = ref<DiseaseData[]>([]);
const userAuthorFollows = ref<UserAuthorFollowData[]>([]);
const content = new Content();
const tag = new Tag();
const disease = new Disease();
const profile = new Profile();
const userAuthorFollow = new UserAuthorFollow();
const userArticleFavorite = new UserArticleFavorite();
const userArticleLike = new UserArticleLike();
const expandedItems = reactive<{ [key: string]: boolean }>({});
const tagListRefs = reactive({});
const previewImage = ref("/server/necs/images/profile_icon.png");
// ランダムなウェルカムメッセージ
const welcomeMessage = ref("");
// セッションエラーチェック
let userInfo = ref<any>(null);
let sessionErr = ref(false);
let nicknameErr = ref(false);
let errorDialog = reactive({
  show: false,
  okName: _$t("home_ok_btn"),
  okButtonHide: true,
  safe: true,
  message: "",
  open: (message: string): void => {
    processing(); // オーバレイを表示
    errorDialog.message = message;
    errorDialog.show = true;
  },
  close: (): void => {
    processend(); // オーバレイを非表示
    errorDialog.show = false;
    errorDialog.message = "";
    if (sessionErr.value) {
      window.location.replace("/cms/login");
    }
  },
  ok: (): void => {
    if (nicknameErr.value) {
      router.push({ name: "ProfileEdit" });
    } else if (sessionErr.value) {
      window.location.replace("/cms/login");
    }
    close();
  },
});
const route = useRoute();
const date = route.query?.date as string;
const tab = ref(route.query?.tab as string);
const nextHospitalVisit = ref<HospitalVisit[]>([]);
const dailyCondition = ref<DailyCondition[]>([]);
const dailyFeelings = ref<DailyFeeling[]>([]);
const dailyNotes = ref<DailyNote[]>([]);
const dailyConditionOptions = ref<Option[]>([]);
const noteCategoryOptions = ref<Option[]>([]);
const feelingOptions = ref<Option[]>([]);
const selectedDate = ref<string>(date ?? dayjs().format("YYYY-MM-DD"));
const todayConditionHiddenFlag = ref<boolean>(false);
const symptomHiddenFlag = ref<boolean>(false);
const home = new Home();

const initialModal = reactive({
  show: false,
  step: 1,
  close: async (): Promise<void> => {
    initialModal.show = false;
    const [_model, _response, err] = await home.setDailyNoteHiddenFlag();
    // エラー判定
    if (err) {
      const status = err.error.response.status;
      const decodedMessage = decodeURIComponent(
        err.error?.response?.data?.message
      );
      // セッションエラー
      if (status === 408) sessionErr.value = true;
      errorDialog.open(decodedMessage);
      return;
    }
  },
  handleNextClick: (): void => {
    initialModal.step++;
  },
});

const isModalOpen = ref<boolean>(tab.value ? true : false);

const handleModalOpen = () => {
  return (isModalOpen.value = true);
};

const handleModalClose = () => {
  return (isModalOpen.value = false);
};

const handleSelectedDateChange = (dateIso: string) => {
  selectedDate.value = dateIso;
  fetchHomeData();
};

// ----- Functions -----------------------------------------------
// アコーディオン高さのチェック（高さ>135px)
const checkTagListHeight = (articleId: string | number): boolean => {
  const tagList = tagListRefs[articleId];
  if (tagList) {
    // total height ul (diseases and tags)
    const totalHeight = tagList.scrollHeight;
    return totalHeight > 135;
  }
  return false;
};
// トグルボタンの状態
const toggleExpand = (articleId: string | number) => {
  if (expandedItems[articleId]) {
    expandedItems[articleId] = false;
  } else {
    expandedItems[articleId] = true;
  }
};
const fetchHomeData = async () => {
  await home.getHomeData(selectedDate.value).then(([model, _response, err]) => {
    if (err) {
      // エラー
      const status = err.error?.response?.status;
      const decodedMessage = decodeURIComponent(
        err.error?.response?.data?.message
      );
      // セッションエラー
      if (status === 408) sessionErr.value = true;
      errorDialog.open(decodedMessage);
      return;
    }
    nextHospitalVisit.value = model.attributes?.nextHospitalVisit ?? [];
    dailyCondition.value = model.attributes?.userDailyCondition || [];
    dailyNotes.value = model.attributes?.userDailyNotes || [];
    dailyFeelings.value = model.attributes?.userDailyFeelings || [];
    dailyConditionOptions.value = model.attributes?.dailyConditionOptions;
    noteCategoryOptions.value = model.attributes?.noteCategoryOptions || [];
    feelingOptions.value = model.attributes?.feelingOptions || [];
    initialModal.show = !model.attributes?.dailyNoteHiddenFlag;
    todayConditionHiddenFlag.value =
      !model.attributes?.todayConditionHiddenFlag;
    symptomHiddenFlag.value = !model.attributes?.symptomHiddenFlag;
  });
};
// お知らせ取得
const fetchNotices = async () => {
  await content.getNotices(size).then(([model, _response, err]) => {
    if (!err) {
      notices.value = model.attributes?.result || [];
    } else {
      // セッションエラー
      const status = err.error?.response?.status;
      if (status === 408) {
        const decodedMessage = decodeURIComponent(
          err.error?.response?.data?.message
        );
        sessionErr.value = true;
        errorDialog.open(decodedMessage);
      }
      return;
    }
  });
};

// 記事取得
const fetchArticles = async () => {
  await content.getArticles(page, size, {}).then(([model, _response, err]) => {
    if (!err) {
      articles.value = model.attributes || [];
    } else {
      // セッションエラー
      const status = err.error?.response?.status;
      if (status === 408) {
        const decodedMessage = decodeURIComponent(
          err.error?.response?.data?.message
        );
        sessionErr.value = true;
        errorDialog.open(decodedMessage);
      }
      return;
    }
  });
};

// 疾患取得
const fetchDiseases = async () => {
  await disease.getUserDiseases().then(([model, _response, err]) => {
    if (!err) {
      diseases.value = model.attributes?.result || [];
    } else {
      // セッションエラー
      const status = err.error?.response?.status;
      if (status === 408) {
        const decodedMessage = decodeURIComponent(
          err.error?.response?.data?.message
        );
        sessionErr.value = true;
        errorDialog.open(decodedMessage);
      }
      return;
    }
  });
};

// タグ取得
const fetchTags = async () => {
  await tag.getUserTags().then(([model, _response, err]) => {
    if (!err) {
      tags.value = model.attributes?.result || [];
    } else {
      // セッションエラー
      const status = err.error?.response?.status;
      if (status === 408) {
        const decodedMessage = decodeURIComponent(
          err.error?.response?.data?.message
        );
        sessionErr.value = true;
        errorDialog.open(decodedMessage);
      }
      return;
    }
  });
};

// フォロー中の提供者取得
const fetchUserAuthorFollows = async () => {
  await userAuthorFollow
    .getUserAuthorFollows()
    .then(([model, _response, err]) => {
      if (!err) {
        userAuthorFollows.value = model.attributes?.result || [];
      } else {
        // セッションエラー
        const status = err.error?.response?.status;
        if (status === 408) {
          const decodedMessage = decodeURIComponent(
            err.error?.response?.data?.message
          );
          sessionErr.value = true;
          errorDialog.open(decodedMessage);
        }
        return;
      }
    });
};

// 記事お気に入り更新
const updateUserArticleFavorites = async (articleId: number, event: Event) => {
  const target = event.target as HTMLInputElement;

  await userArticleFavorite
    .updateUserArticleFavorites(articleId)
    .then(([model, _response, err]) => {
      if (err) {
        target.checked = !target.checked;
        // セッションエラー
        const status = err.error?.response?.status;
        if (status === 408 || status === 403) {
          const decodedMessage = decodeURIComponent(
            err.error?.response?.data?.message
          );
          sessionErr.value = true;
          errorDialog.open(decodedMessage);
        }
        return;
      } else {
        const result = model.attributes?.result;
        target.checked = result;

        const article = articles.value.find((a) => a.articleId === articleId);
        if (article) {
          article.isFavorite = result;
        }
      }
    });
};

// 記事いいね更新
const updateUserArticleLikes = async (articleId: number, event: Event) => {
  const target = event.target as HTMLInputElement;

  await userArticleLike
    .updateUserArticleLikes(articleId, !target.checked)
    .then(([model, _response, err]) => {
      if (err) {
        // セッションエラー
        const status = err.error?.response?.status;
        if (status === 408 || status === 403) {
          const decodedMessage = decodeURIComponent(
            err.error?.response?.data?.message
          );
          sessionErr.value = true;
          errorDialog.open(decodedMessage);
        }
        return;
      } else {
        const result = model.attributes?.result;

        const article = articles.value.find((a) => a.articleId === articleId);
        if (article) {
          article.likeCount = result;
          article.isLiked = !article.isLiked;
        }
      }
    });
};

// お知らせ一覧ページへ遷移
const goToNoticePage = () => {
  router.push({
    name: "notifications",
  });
};

// 記事一覧ページへ遷移
const goToArticlePage = () => {
  router.push({
    name: "article",
  });
};

// 記事一覧ページへ遷移（条件あり）
const goToArticlePageByCond = (cond?: ArticleQueryCond) => {
  router.push({
    name: "article/search",
    query: {
      cond: encodeURIComponent(JSON.stringify(cond)),
    },
  });
};

// お知らせ詳細ページへ遷移
const goToNoticeDetailPage = (articleId: number) => {
  if (!articleId) return;

  router.push({
    name: "notice/detail",
    params: { articleId },
  });
};

// 記事詳細ページへ遷移
const goToArticleDetailPage = (articleId: number) => {
  if (!articleId) return;

  router.push({
    name: "article/detail",
    params: { articleId },
  });
};

// タイトルを38文字以内に…で切り捨てる
const truncateTitle = (title: string): string => {
  if (!title) return "";

  if (title.length > 38) {
    return title.slice(0, 37) + "…";
  }

  return title;
};

// ユーザーがログインした直後にニックネームをチェック
const checkNickname = () => {
  //ストアの checkNickname フラグを確認
  if (store.getters.getCheckHasNickname) {
    return true;
  }
  // フラグが false の場合、ニックネームが未設定とみなし、警告を表示する
  store.commit("setCheckHasNickname", true);

  const nickname = userInfo.value?.nickname || null;
  //ニックネームが設定されていない場合は、警告メッセージを表示する
  if (!nickname || nickname.trim() === "") {
    const nicknameMessage = _$t("home_nickname_create_msg");
    errorDialog.okName = _$t("home_nickname_create_btn");
    nicknameErr.value = true;
    errorDialog.open(nicknameMessage);
    return false;
  }
};

// ランダムなウェルカムメッセージを生成
const generateRandomWelcomeMessage = () => {
  const messageKeys = Object.keys(code.attributes.randomWelcomeMessage);
  const randomIndex = Math.floor(Math.random() * messageKeys.length);
  const randomKey = messageKeys[randomIndex];
  welcomeMessage.value = code.attributes.randomWelcomeMessage[randomKey];
};

//画像取得
const fetchImage = async () => {
  await profile.getProfileInfo().then(([model, _response, err]) => {
    if (err) {
      const decodedMessage = decodeURIComponent(
        err.error?.response?.data?.message
      );
      // セッションエラー
      const status = err.error.response.status;
      if (status === 408) sessionErr.value = true;
      errorDialog.open(decodedMessage);
      return;
    } else {
      const image = model.attributes?.result?.image;
      if (image) {
        previewImage.value = image;
      }
    }
  });
};

const fetchHasNewNotification = async () => {
  await home.hasNewNotice().then(([model, _response, err]) => {
    if (err) {
      // エラー
      const status = err.error?.response?.status;
      const decodedMessage = decodeURIComponent(
        err.error?.response?.data?.message
      );
      // セッションエラー
      if (status === 408) sessionErr.value = true;
      errorDialog.open(decodedMessage);
      return;
    }
    store.commit("setHasNewNotification", _response.data?.hasNewNotice);
  });
};

// 常設バナーリンク
const openArticleCondition = () => {
  window.open("https://member.kanshin-hiroba.jp/cms#/article/detail/394");
};

const openArticleClinicNote = () => {
  window.open("https://member.kanshin-hiroba.jp/cms#/article/detail/395");
};

// ---- Vue lifeCycle ----------------------------------------------
onMounted(async () => {
  // ユーザー情報を取得
  const refreshUserInfo = inject<() => any>("refreshUserInfo");
  if (refreshUserInfo) {
    userInfo.value = await refreshUserInfo();
  }
  // ランダムなウェルカムメッセージを生成
  generateRandomWelcomeMessage();
  await fetchImage();
  await fetchNotices();
  await fetchArticles();
  await fetchTags();
  await fetchDiseases();
  await fetchUserAuthorFollows();
  await fetchHomeData();
  await fetchHasNewNotification();
  checkNickname();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", { id: componentId }, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(Header, {
          "active-menu": activeMenu,
          nickname: _unref(userInfo)?.nickname,
          "welcome-message": welcomeMessage.value,
          "preview-image": previewImage.value,
          "next-visit": nextHospitalVisit.value,
          "daily-condition": dailyCondition.value,
          "daily-feelings": dailyFeelings.value,
          "daily-notes": dailyNotes.value,
          "daily-condition-options": dailyConditionOptions.value,
          "today-condition-hidden-flag": todayConditionHiddenFlag.value,
          "symptom-hidden-flag": symptomHiddenFlag.value,
          onGetHomeData: fetchHomeData,
          onOpenModal: handleModalOpen,
          onSelectedDateChange: handleSelectedDateChange
        }, null, 8, ["nickname", "welcome-message", "preview-image", "next-visit", "daily-condition", "daily-feelings", "daily-notes", "daily-condition-options", "today-condition-hidden-flag", "symptom-hidden-flag"]),
        _createElementVNode("main", null, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _cache[7] || (_cache[7] = _createElementVNode("img", { src: "/server/necs/images/recommend_icon.png" }, null, -1)),
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("home_msg_recommendedArticle")), 1)
              ]),
              _createElementVNode("div", {
                class: "recs-list",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (goToArticlePage()))
              }, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("home_link_checkMore")), 1),
                _cache[8] || (_cache[8] = _createElementVNode("img", { src: "/server/necs/images/arrow-right_icon.png" }, null, -1))
              ])
            ]),
            _createElementVNode("ul", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(articles.value, (article, i) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: "recs-contents-items",
                  key: article.articleId
                }, [
                  _createElementVNode("div", {
                    class: "sp-wrapper",
                    onClick: ($event: any) => (goToArticleDetailPage(article.articleId))
                  }, [
                    _createElementVNode("img", {
                      class: "content-item-img",
                      id: "cover_photo",
                      src: article.coverPhotoUrl
                    }, null, 8, _hoisted_7),
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["content-item-new", { none: !article.isNew }])
                      }, _toDisplayString(article.isNew ? _ctx.$t("home_msg_newContent") : ""), 3),
                      _createElementVNode("div", _hoisted_9, _toDisplayString(truncateTitle(article.title)), 1)
                    ])
                  ], 8, _hoisted_6),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("ul", {
                      class: _normalizeClass(["content-item-tags", { heightExpanded: expandedItems[article.articleId] }]),
                      ref_for: true,
                      ref: (el) => (tagListRefs[article.articleId] = el)
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(article.diseases, (disease, j) => {
                        return (_openBlock(), _createElementBlock("li", {
                          class: "tag-item tag-disease",
                          key: j,
                          onClick: ($event: any) => (
                      goToArticlePageByCond({
                        diseaseCodes: [disease.diseaseCode],
                      })
                    )
                        }, _toDisplayString(disease.diseaseName), 9, _hoisted_11))
                      }), 128)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(article.tags, (tag, j) => {
                        return (_openBlock(), _createElementBlock("li", {
                          class: "tag-item tag-interest",
                          key: j,
                          onClick: ($event: any) => (goToArticlePageByCond({ tagIds: [tag.tagId] }))
                        }, _toDisplayString(tag.tagName), 9, _hoisted_12))
                      }), 128))
                    ], 2),
                    (checkTagListHeight(article.articleId))
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (!expandedItems[article.articleId])
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "contents-height-all",
                                onClick: ($event: any) => (toggleExpand(article.articleId))
                              }, [
                                _createElementVNode("span", null, _toDisplayString(_ctx.$t("article_tab_recommend_search_show")), 1),
                                _cache[9] || (_cache[9] = _createElementVNode("img", {
                                  src: "/server/necs/images/arrow-right_icon.png",
                                  alt: "Show more"
                                }, null, -1))
                              ], 8, _hoisted_13))
                            : _createCommentVNode("", true),
                          (expandedItems[article.articleId])
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                class: "contents-height-hide",
                                onClick: ($event: any) => (toggleExpand(article.articleId))
                              }, [
                                _createElementVNode("span", null, _toDisplayString(_ctx.$t("article_tab_recommend_search_hidden")), 1),
                                _cache[10] || (_cache[10] = _createElementVNode("img", {
                                  src: "/server/necs/images/arrow-right_icon.png",
                                  alt: "Show less"
                                }, null, -1))
                              ], 8, _hoisted_14))
                            : _createCommentVNode("", true)
                        ], 64))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, _toDisplayString(article.dateFirstPublished), 1),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _createTextVNode(_toDisplayString(_ctx.$t("home_msg_author")), 1),
                        _createElementVNode("span", {
                          class: "writer-name-area",
                          onClick: ($event: any) => (
                        goToArticlePageByCond({
                          posterIds: [article.poster.adminId],
                        })
                      )
                        }, _toDisplayString(article.poster.nickname), 9, _hoisted_19)
                      ]),
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("input", {
                          type: "checkbox",
                          class: "writer-like",
                          id: `like-toggle${i}`,
                          checked: article.isLiked,
                          onChange: 
                        (e) => updateUserArticleLikes(article.articleId, e)
                      
                        }, null, 40, _hoisted_21),
                        _createElementVNode("label", {
                          for: `like-toggle${i}`,
                          class: "like-icon"
                        }, null, 8, _hoisted_22),
                        _withDirectives(_createElementVNode("p", null, "いいね", 512), [
                          [_vShow, article.likeCount === 0]
                        ]),
                        _withDirectives(_createElementVNode("p", null, _toDisplayString(article.likeCount), 513), [
                          [_vShow, article.likeCount > 0]
                        ])
                      ]),
                      _createElementVNode("input", {
                        type: "checkbox",
                        class: "writer-follow",
                        id: `follow-toggle${i}`,
                        checked: article.isFavorite,
                        onChange: 
                      (e) => updateUserArticleFavorites(article.articleId, e)
                    
                      }, null, 40, _hoisted_23),
                      _createElementVNode("label", {
                        for: `follow-toggle${i}`,
                        class: "follow-icon"
                      }, null, 8, _hoisted_24)
                    ])
                  ])
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _cache[11] || (_cache[11] = _createElementVNode("img", { src: "/server/necs/images/search_icon.svg" }, null, -1)),
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("home_msg_searchByMyInfo")), 1)
              ]),
              _createElementVNode("ul", _hoisted_28, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(diseases.value, (disease, i) => {
                  return (_openBlock(), _createElementBlock("li", {
                    class: "search-tag tag-disease",
                    key: i,
                    onClick: ($event: any) => (
                  goToArticlePageByCond({ diseaseCodes: [disease.diseaseCode] })
                )
                  }, _toDisplayString(disease.diseaseName), 9, _hoisted_29))
                }), 128)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tags.value, (tag, i) => {
                  return (_openBlock(), _createElementBlock("li", {
                    class: "search-tag tag-interest",
                    key: i,
                    onClick: ($event: any) => (goToArticlePageByCond({ tagIds: [tag.tagId] }))
                  }, _toDisplayString(tag.tagName), 9, _hoisted_30))
                }), 128))
              ]),
              (userAuthorFollows.value.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_31, _toDisplayString(_ctx.$t("home_msg_followingAuthor")), 1))
                : _createCommentVNode("", true),
              _createElementVNode("ul", _hoisted_32, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userAuthorFollows.value, (author, i) => {
                  return (_openBlock(), _createElementBlock("li", {
                    class: "search-writer",
                    key: i,
                    onClick: ($event: any) => (goToArticlePageByCond({ posterIds: [author.posterId] }))
                  }, _toDisplayString(author.nickname), 9, _hoisted_33))
                }), 128))
              ])
            ])
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "contents-list-button",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (goToArticlePage()))
          }, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("home_button_checkMoreArticle")), 1),
            _cache[12] || (_cache[12] = _createElementVNode("img", { src: "/server/necs/images/arrow-right_icon.png" }, null, -1))
          ]),
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("div", _hoisted_36, [
                _cache[13] || (_cache[13] = _createElementVNode("img", { src: "/server/necs/images/news-icon.png" }, null, -1)),
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("home_msg_notice")), 1)
              ]),
              _createElementVNode("div", {
                class: "notice-list",
                onClick: goToNoticePage
              }, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("home_link_checkNoticePage")), 1),
                _cache[14] || (_cache[14] = _createElementVNode("img", { src: "/server/necs/images/arrow-right_icon.png" }, null, -1))
              ])
            ]),
            _createElementVNode("ul", _hoisted_37, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(notices.value, (notice, i) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: "notice-content-item",
                  key: i,
                  onClick: ($event: any) => (goToNoticeDetailPage(notice.articleId))
                }, [
                  _createElementVNode("span", _hoisted_39, _toDisplayString(notice.dateFirstPublished), 1),
                  _createElementVNode("span", _hoisted_40, _toDisplayString(notice.title), 1),
                  _createElementVNode("img", {
                    class: _normalizeClass(["badge-new-notice-list", { active: !notice.isRead }]),
                    src: "/server/necs/images/badge_new_notice.svg"
                  }, null, 2)
                ], 8, _hoisted_38))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_41, [
            _createElementVNode("img", {
              src: "/server/necs/images/banner_system_usage.png",
              onClick: openArticleCondition
            }),
            _createElementVNode("img", {
              src: "/server/necs/images/bana_img02.png",
              onClick: openArticleClinicNote
            }),
            _createElementVNode("img", {
              src: "/server/necs/images/banner_welfare_usage.png",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(router).push('/welfare')))
            })
          ])
        ]),
        _createVNode(Footer, {
          "scroll-target": componentId,
          "active-menu": activeMenu
        })
      ])
    ]),
    (_unref(errorDialog).show)
      ? (_openBlock(), _createBlock(ErrorDialog, _mergeProps({ key: 0 }, _unref(errorDialog), {
          onOk: _unref(errorDialog).ok,
          onCancel: _unref(errorDialog).close
        }), null, 16, ["onOk", "onCancel"]))
      : _createCommentVNode("", true),
    _createVNode(Modal, {
      title: _ctx.$t('home_modal_title_today_detail_record'),
      "is-open": isModalOpen.value,
      "selected-date": selectedDate.value,
      "daily-feelings": dailyFeelings.value,
      "daily-notes": dailyNotes.value,
      "note-category-options": noteCategoryOptions.value,
      "feeling-options": feelingOptions.value,
      "selected-tab": tab.value,
      onCloseModal: handleModalClose,
      onGetHomeData: fetchHomeData
    }, null, 8, ["title", "is-open", "selected-date", "daily-feelings", "daily-notes", "note-category-options", "feeling-options", "selected-tab"]),
    (initialModal.show)
      ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
          _cache[19] || (_cache[19] = _createElementVNode("div", { class: "modal-overlay" }, null, -1)),
          _createElementVNode("div", _hoisted_43, [
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("button", {
                type: "button",
                class: "modal-close",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (initialModal.close && initialModal.close(...args)))
              }, _cache[15] || (_cache[15] = [
                _createElementVNode("img", { src: "/server/necs/images/close-btn.png" }, null, -1)
              ]))
            ]),
            _createElementVNode("div", _hoisted_45, [
              (initialModal.step === 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                    _cache[16] || (_cache[16] = _createElementVNode("img", {
                      class: "popup-contents-img",
                      src: "/server/necs/images/home_popup_1.gif"
                    }, null, -1)),
                    _createElementVNode("p", _hoisted_47, _toDisplayString(_ctx.$t("home_initial_modal_title_1")), 1),
                    _createElementVNode("p", _hoisted_48, _toDisplayString(_ctx.$t("home_initial_modal_body_content_1")), 1)
                  ]))
                : (initialModal.step === 2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                      _cache[17] || (_cache[17] = _createElementVNode("img", {
                        class: "popup-contents-img",
                        src: "/server/necs/images/home_popup_2.gif"
                      }, null, -1)),
                      _createElementVNode("p", _hoisted_50, _toDisplayString(_ctx.$t("home_initial_modal_title_2")), 1),
                      _createElementVNode("p", _hoisted_51, _toDisplayString(_ctx.$t("home_initial_modal_body_content_2")), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_52, [
                      _cache[18] || (_cache[18] = _createElementVNode("img", {
                        class: "popup-contents-img",
                        src: "/server/necs/images/home_popup_3.gif"
                      }, null, -1)),
                      _createElementVNode("p", _hoisted_53, _toDisplayString(_ctx.$t("home_initial_modal_title_3")), 1),
                      _createElementVNode("p", _hoisted_54, [
                        _createElementVNode("span", {
                          innerHTML: _ctx.$t('home_initial_modal_body_content_3')
                        }, null, 8, _hoisted_55)
                      ])
                    ])),
              _createElementVNode("ul", _hoisted_56, [
                _createElementVNode("li", {
                  class: _normalizeClass(["popup-pagination-item", initialModal.step === 1 ? 'active' : ''])
                }, null, 2),
                _createElementVNode("li", {
                  class: _normalizeClass(["popup-pagination-item", initialModal.step === 2 ? 'active' : ''])
                }, null, 2),
                _createElementVNode("li", {
                  class: _normalizeClass(["popup-pagination-item", initialModal.step === 3 ? 'active' : ''])
                }, null, 2)
              ])
            ]),
            _createElementVNode("div", _hoisted_57, [
              _createElementVNode("div", _hoisted_58, [
                (initialModal.step === 3)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "modal-button-next home-popup-button-next",
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (initialModal.close && initialModal.close(...args)))
                    }, _toDisplayString(_ctx.$t("home_initial_modal_button_try")), 1))
                  : (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      type: "button",
                      class: "modal-button-next",
                      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (initialModal.handleNextClick && initialModal.handleNextClick(...args)))
                    }, _toDisplayString(_ctx.$t("home_initial_modal_button_next")), 1)),
                _createElementVNode("button", {
                  type: "button",
                  class: "modal-button-close",
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (initialModal.close && initialModal.close(...args)))
                }, _toDisplayString(_ctx.$t("home_initial_modal_button_close")), 1)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})